<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="manInfo"
               :rules="manRules"
               ref="manForm"
               label-width="130px"
               class="man-form">
        <el-form-item label="维修人名称："
                      prop="name">
          <el-input v-model.trim="manInfo.name"
                    placeholder="请输入维修人名称"></el-input>
        </el-form-item>
        <el-form-item label="联系方式："
                      prop="contact_ctx">
          <el-input v-model.trim="manInfo.contact_ctx"
                    placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="通知方式："
                      prop="contact_type">
          <el-select v-model="manInfo.contact_type"
                     placeholder="请选择通知方式">
            <el-option v-for="(item, index) in typeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/repairman/add' || '/repairman/edit'"
                 type="primary"
                 @click="handleConfirm('manForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
import validate from '@/common/validate'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      manInfo: {
        name: '',
        contact_ctx: '',
        contact_type: ''
      },
      manRules: {
        name: [{ required: true, message: '请输入维修人名称' }],
        contact_ctx: [
          { required: true, message: '请输入维修人联系方式' },
          { validator: validate.tel, trigger: 'blur' }
        ],
        contact_type: [{ required: true, message: '请选择通知类型' }]
      },
      typeList: []
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加维修人' : '编辑维修人'
    }
  },
  created() {
    this.getItemList()
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getRepairManInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.manInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取通知方式
    getItemList() {
      fetch.getItemList({ type_code: 'contact_type' }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addRepairMan({ ...this.manInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editRepairMan({ ...this.manInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
